import React, { useState } from 'react';
import { Collapse, Icon } from 'antd';
import { FormatText, FormSubmitButton, FormSwitch, MasterDetailForm, usePromise, Widget } from '@digital/ui';
import { GetAtivacaoContrato, ParametrosAtivacaoContrato, UpdateAtivacaoContrato } from '@app/api/configuracoes';

const { Panel } = Collapse;

const ConfiguracaoAtivacaoContrato = () => {
  const [versao, setVersao] = useState(false);
  const [dados] = usePromise(async () => await GetAtivacaoContrato(), [versao], {
    ativacaoContratoAutomaticaHabilitada: false,
  });

  const atualizar = (values: ParametrosAtivacaoContrato) => {
    UpdateAtivacaoContrato(values).then(resultado => {
      if (resultado.valid) {
        setVersao(!versao);
      }
    });
  };

  return (
    <Collapse bordered={false} expandIcon={() => <Icon type="arrows-right_4" />}>
      <Panel key="configuracoesAtivacaoContrato" header="Ativação automática de contratos">
        <MasterDetailForm initialValues={dados} onSubmit={atualizar}>
          <Widget
            actions={[
              <FormSubmitButton noIcon type="primary">
                <FormatText id="ui.commons.save" uppercase />
              </FormSubmitButton>,
            ]}>
            <FormSwitch
              label="Ativar automaticamente após análise e preenchimento"
              name="ativacaoContratoAutomaticaHabilitada"
              span={4}
            />
          </Widget>
        </MasterDetailForm>
      </Panel>
    </Collapse>
  );
};

export default ConfiguracaoAtivacaoContrato;
